module.exports = __webpack_public_path__ + "img/unlock.ba3c0fdb.svg";